export const setConfigsQuery = async (data) => {
    const domain_id = data.domain_id;
    delete data.domain_id;
    if (data.best_translation && !Array.isArray(data.best_translation)) {
        data.best_translation = data.best_translation?.split(',')?.map((item) => item.trim()) ?? [];
    }
    if (data.branded_terms && !Array.isArray(data.branded_terms)) {
        data.branded_terms = data.branded_terms?.split(',')?.map((item) => item.trim()) ?? [];
    }
    if (data.questions && !Array.isArray(data.questions)) {
        data.questions = data.questions?.split(',')?.map((item) => item.trim()) ?? [];
    }
    return fetch(`/api/v1/domains/config/${domain_id}/`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
        body: JSON.stringify(data),
    });
};
